var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticStyle:{"height":"30px"},attrs:{"size":"small","type":"error","icon":"md-trash"},on:{"click":function($event){return _vm.$emit('on-click')}}},[_vm._v("删除")])}
var staticRenderFns = []

export { render, staticRenderFns }